export default __webpack_public_path__ + "icons/android-chrome-192x192-756917656a02fcaf88c0f030da824eba.png";